import { render } from "./StepThreeGroup.vue?vue&type=template&id=6907fae2"
import script from "./StepThreeGroup.vue?vue&type=script&lang=js"
export * from "./StepThreeGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-user-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__